export const environment = {
    production: false
    , appBaseUrl: 'https://dev-scb.iapmo.org/'
    , apiBaseUrl: 'https://dev-scb-api.iapmo.org/'
    , mediaBaseUrl: 'https://scb-media.iapmo.org/'
    , defaultDocumentReviewerName: 'Shirley Dewii'
    , defaultDocumentApproverName: 'Shirley Dewii'
    , defaultAllItemsPerPage: 100000
    , defaultItemsPerPage: 100
    , defaultItemsPerPageForDashboard: 10
    , defaultHourlyTravelRate: 40
    , recaptcha: {
        sitekey: '6LcJ3YEUAAAAADtOODwFwbofeu29BTvJWLQRlXDX',
    }
    , applicableAdditionalStandard: {
        'ISO_13485_2016': 'ISO 13485:2016',
        'ISO_9001_2015': 'ISO 9001:2015',
        'ISO_9001_2000': 'ISO 9001:2000',
        'ISO_9001_2008': 'ISO 9001:2008',
        'SNI_9001_2008': 'SNI 9001-2008',
        'ISO_14001_2004': 'ISO 14001:2004',
        'ISO_14001_2015': 'ISO 14001:2015',
        'SNI_19_14001_2005': 'SNI 19-14001-2005',
    }
    , asOtherStandards: {
        'ARP9136': 'Aerospace Series - Root Cause Analysis and Problem Solving (9S Methodology)',
        'ARP9137': 'Guidance for the Application of AQAP 2110 within a 9100 Quality Management System',
        'AS9116': 'Aerospace Series - Notice of Change (NOC) Requirements',
        'AS9117': 'Delegated Product Release Verification',
        'AS9138': 'Aerospace Series - Quality Management Systems Statistical Product Acceptance Requirements',
        'AS9145': 'Aerospace Series - Requirements for Advanced Product Quality Planning and Production Part Approval Process',
        'AS9146': 'Foreign Object Damage (FOD) Prevention Program - Requirements for Aviation, Space, and Defense Organizations',
        'AS9162': 'Aerospace Operator Self-Verification Programs',
        'AS9017': 'Control of Aviation Critical Safety Items',
        'ARP9107A': 'Direct Delivery Authorization Guidance for Aerospace Companies',
        'ARP9114A': 'Direct Ship Guidance for Aerospace Companies',
        'AS9003A': 'Inspection and Test Quality Systems, Requirements for Aviation, Space, and Defense Organizations',
        'AS9102B': 'Aerospace First Article Inspection Requirement',
        'AS9103A': 'Aerospace Series - Quality Management Systems - Variation Management of Key Characteristics',
        'AS9115A': 'Quality Management Systems - Requirements for Aviation, Space, and Defense Organizations - Deliverable Software(Supplement to 9100:2016)',
        'AS9131C': 'Aerospace Series - Quality Management Systems - Nonconformance Data Definition and Documentation',
        'AS9132B': 'Data Matrix Quality Requirements for Parts Marking',
        'AS9133A': 'Qualification Procedure for Aerospace Standard Products',
        'ARP9005A': 'Aerospace Guidance for Non-Deliverable Software',
        'ARP9009A': 'Aerospace Contract Clauses',
        'ARP9034A': 'A Process Standard for the Storage, Retrieval and Use of Three-Dimensional Type Design Data',
        'ARP9090A': 'Requirements for Industry Standard e-Tool to Collaborate Quality Assurance Activities Among Customers and Suppliers',
        'ARP9134A': 'Supply Chain Risk Management Guideline',
        'AS9006A': 'Deliverable Aerospace Software Supplement for AS9100A, Quality Management Systems - Aerospace - Requirements for Software (based on AS9100A)',
    }
    , asOtherStandardsReleaseDate: {
        'ARP9136': '2016-11-08',
        'ARP9137': '2010-05-06',
        'AS9116': '2014-10-30',
        'AS9117': '2016-03-29',
        'AS9138': '2018-01-20',
        'AS9145': '2016-11-08',
        'AS9146': '2017-04-26',
        'AS9162': '2016-11-08',
        'AS9017': '2017-03-17',
        'ARP9107A': '2017-11-09',
        'ARP9114A': '2014-02-06',
        'AS9003A': '2012-07-31',
        'AS9102B': '2014-10-06',
        'AS9103A': '2012-08-16',
        'AS9115A': '2017-02-01',
        'AS9131C': '2012-08-16',
        'AS9132B': '2015-05-19',
        'AS9133A': '2016-04-20',
        'ARP9005A': '2016-06-27',
        'ARP9009A': '2017-06-21',
        'ARP9034A': '2015-04-21',
        'ARP9090A': '2014-02-06',
        'ARP9134A': '2014-02-06',
        'AS9006A': '2013-07-09',
    },
    roleTabs: {
        'customer': ['Customer']
        , 'client': ['Client']
        , 'mmr': ['MMR']
        , 'admin': ['Admin']
        , 'salesRep': ['SR-US', 'SVP', 'CM', 'CD']
        , 'certificationDirector': ['CD']
        , 'salesManager': ['SVP', 'CSM-PT', 'CM', 'GM-PT', 'CD']
        , 'svp': ['SVP']
        , 'auditor': ['Auditor'] //['CA-PT', 'CA-US']
        , 'auditorAdmin': ['AA']
    }
    , mapKey: 'AIzaSyBj6vFSJAINm4LBEvcI-ZmeBe2h7Qh5KL0'
    , refreshTokenMinutes: 20
};
